import { createContext, useContext } from 'react'

export type ExcludedOptionsLookup = (fieldId: string) => unknown[]

export const ExcludedOptionsContext = createContext<ExcludedOptionsLookup>(() => [])

export const useExcludedOptionValues = (fieldId: string): unknown[] => useContext(ExcludedOptionsContext)(fieldId)
